import React from "react";
import { ShopTheLookDisplay } from "~/common/Store/models/Brand";
import ShopTheLookProductTagView from "./ShopTheLookProductTagView";

interface Props {
  index: number;
  title: string;
  display: ShopTheLookDisplay;
  isMobile?: boolean;
  isActive: boolean;
  setActiveTagIndex: React.Dispatch<React.SetStateAction<number | null>>;
}

const ShopTheLookDeviceView = ({
  index,
  title,
  display,
  isMobile = false,
  isActive,
  setActiveTagIndex,
}: Props) => {
  return (
    <li
      key={`Look${index + 1}`}
      className={`shop-look__photo-${isMobile ? "sm" : "lg"} shop-look__item${
        isActive || isMobile ? " active" : ""
      }`}
      title={title}
    >
      <img
        src={display.image}
        alt={title}
        className="shop-look__photo"
        width={isMobile ? "900" : "1600"}
      />
      <div className="shop-look__tags">
        {display.productTags.map((tag, tagIndex) => (
          <ShopTheLookProductTagView
            tag={tag}
            key={`ShopTheLookTag${tagIndex}`}
            index={tagIndex}
            setActiveTagIndex={setActiveTagIndex}
          />
        ))}
      </div>
    </li>
  );
};

export default ShopTheLookDeviceView;
